// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.object("User", {
  id: __t.u64(),
  username: __t.string(),
  displayName: __t.string(),
  countryCode: __t.string(),
  profilePictureId: __t.option(__t.string()),
  eloRating: __t.i32(),
  gamesWon: __t.u32(),
  gamesLost: __t.u32(),
  lastActiveAt: __t.u64(),
  isGuest: __t.bool(),
  email: __t.option(__t.string()),
  passwordHash: __t.option(__t.string()),
  createdAt: __t.u64(),
  bio: __t.option(__t.string()),
  eloRanked: __t.i32(),
  eloRace: __t.i32(),
  eloTurnTactics: __t.i32(),
  peakEloRanked: __t.i32(),
  rankedWins: __t.u32(),
  rankedLosses: __t.u32(),
  rankedGamesPlayed: __t.u32(),
  raceMmWins: __t.u32(),
  raceMmLosses: __t.u32(),
  raceMmGamesPlayed: __t.u32(),
  ttMmWins: __t.u32(),
  ttMmLosses: __t.u32(),
  ttMmGamesPlayed: __t.u32(),
  googleId: __t.option(__t.string()),
  currentWinStreak: __t.u32(),
  bestWinStreak: __t.u32(),
  beginnerWins: __t.u32(),
  intermediateWins: __t.u32(),
  expertWins: __t.u32(),
  totalXp: __t.u64(),
  coinsBalance: __t.i64(),
  vipTier: __t.u32(),
  glickoMu: __t.i32(),
  glickoRd: __t.i32(),
  glickoSigma: __t.i32(),
  rankPoints: __t.i32(),
  placementGamesPlayed: __t.u32(),
  placementCompleted: __t.bool(),
  firstWinClaimedAt: __t.u64(),
  demotionShields: __t.u32(),
  lastPromotionAt: __t.u64(),
});


